import { atom } from 'jotai';

const filtersAtom = atom({
  cdn: '',
  asn: '',
  policy: '',
  triggerKpi: '',
  blacklistedKpi: '',
  blackListCondition: '=',
  duration: '',
  durationCondition: '=',
  referenceKpi: '',
  referenceCondition: '=',
  kpiSampleSize: '',
  sampleSizeCondition: '=',
});

export default filtersAtom;
